import moment from "moment";
import React, { useEffect, useState } from "react";
import { TbRefresh } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import { showHideFilterModalReducer } from "../../../../data/redux/slice/globalFiltersSlice";
import { modififyDropdownServiceProviderNameList } from "../../../../services/fetchDropdownListData";
import { fetchTransactionList } from "../../../../services/fetchListingData";
import secureStorage from "../../../../services/secureStorage";
import { primaryColor } from "../../../../utility/constants/colorManager";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import {
  CLIENT,
  RESELLER,
  STATUS_CODE_200,
  TRANSACTION_ALL_ACL,
  TRANSACTION_CREDITED,
  TRANSACTION_DEBITED,
  TRANSACTION_DOWNLOAD_REPORT_ACL,
  TRANSACTION_FAILED,
  TRANSACTION_FAILED_ACL,
  TRANSACTION_FILTER_ACL,
  TRANSACTION_PAYIN_ACL,
  TRANSACTION_PAYOUT_ACL,
  TRANSACTION_PENDING,
  TRANSACTION_PREFUND_ACL,
  TRANSACTION_REFUND,
  TRANSACTION_REFUND_ACL,
  TRANSACTION_VAN_ACL,
  VOUCHER_TRANSACTION_LIST
} from "../../../../utility/constants/valueConstants";
import { setTabsAccToAcl } from "../../../../utility/convertors";
import { CustomButton } from "../../../components/main_comps/custom_button";
import CustomModal from "../../../components/main_comps/custom_modal";
import CustomSelect from "../../../components/main_comps/custom_select";
import CustomTabs from "../../../components/main_comps/custom_tabs";
import MainComponent from "../../../components/ui_comps/MainComponent";
import DownloadReportModal from "./DownloadReportModal";
import PayinTransaction from "./PayinTransaction";
import PayoutTransaction from "./PayoutTransaction";
import PrefundTransaction from "./PrefundTransaction";
import VanTransaction from "./VanTransaction";
import VoucherTransaction from "./VoucherTransaction";

const FilterComponent = ({
  onPress,
  onRefreshPress,
  currentTab,
  onChange,
  aclData
}) => {
  const [currentService, setCurrentService] = useState({});
  const role = secureStorage.getItem(SS_ROLE);
  const [payinServiceList, setPayinServiceList] = useState([]);
  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);
  const [payoutServiceList, setPayoutServiceList] = useState([]);
  const [vanServiceList, setVanServiceList] = useState([]);

  const modififyDropdownServiceProviderNameList = (data) => {
    let arr = [];
    data &&
      data?.map((val, i) => {
        arr.push({
          value: val?.serviceProviderName,
          label: val.serviceProviderName
        });
      });

    return arr;
  };

  const fetchPayinDropDown = () => {
    ApiRequestGet.getAllServiceProviderList({
      type: "payin"
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setPayinServiceList(
            modififyDropdownServiceProviderNameList(res.data)
          );
        }
      })
      .catch((err) => {});
  };

  const fetchPayoutDropDown = () => {
    ApiRequestGet.getAllServiceProviderList({
      type: "payout"
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setPayoutServiceList(
            modififyDropdownServiceProviderNameList(res.data)
          );
        }
      })
      .catch((err) => {});
  };

  const fetchVanDropDown = () => {
    ApiRequestGet.getAllServiceProviderList({
      type: "van"
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          let Data = modififyDropdownServiceProviderNameList(res.data);
          const modifdData = Data.filter((item) => item.value !== "Equitas");
          setVanServiceList(modifdData);
        }
      })
      .catch((err) => {});
  };

  const fetchResellerPayinDropDown = () => {
    ApiRequestGet.fetchResellerServiceProvider({
      servicetype: "payin"
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setPayinServiceList(
            modififyDropdownServiceProviderNameList(res.data)
          );
        }
      })
      .catch((err) => {});
  };

  const fetchResellerPayoutDropDown = () => {
    ApiRequestGet.fetchResellerServiceProvider({
      servicetype: "payout"
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setPayoutServiceList(
            modififyDropdownServiceProviderNameList(res.data)
          );
        }
      })
      .catch((err) => {});
  };

  const fetchResellerVanDropDown = () => {
    ApiRequestGet.fetchResellerServiceProvider({
      servicetype: "van"
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          let Data = modififyDropdownServiceProviderNameList(res.data);
          const modifdData = Data.filter(
            (item) => item.value.toLowerCase() !== "equitas"
          );
          setVanServiceList(modifdData);
        }
      })
      .catch((err) => {});
  };
  useEffect(() => {
    if (currentTab === 2 || currentTab === 3) {
      setCurrentService(payoutServiceList[0]);
    } else if (currentTab === 4) {
      setCurrentService(vanServiceList[0]);
    } else if (currentTab === 5) {
      setCurrentService("neokred");
    } else {
      setCurrentService(payinServiceList[0]);
    }
  }, [currentTab, payinServiceList, payoutServiceList, vanServiceList]);

  useEffect(() => {
    if (aclData.includes(TRANSACTION_PAYIN_ACL)) {
      if (role?.toUpperCase() === RESELLER) {
        fetchResellerPayinDropDown();
      } else {
        fetchPayinDropDown();
      }
    }

    if (aclData.includes(TRANSACTION_PAYOUT_ACL)) {
      if (role?.toUpperCase() === RESELLER) {
        fetchResellerPayoutDropDown();
      } else {
        fetchPayoutDropDown();
      }
    }

    if (aclData.includes(TRANSACTION_VAN_ACL)) {
      if (role?.toUpperCase() === RESELLER) {
        fetchResellerVanDropDown();
      } else {
        fetchVanDropDown();
      }
    }
  }, []);

  useEffect(() => {
    if (currentTab === 1) {
      onChange(currentService?.value);
    } else if (currentTab === 2 || currentTab === 3) {
      onChange(currentService?.value);
    } else if (currentTab === 5) {
      onChange("neokred");
    } else {
      onChange(currentService?.value);
    }
  }, [currentService, payoutServiceList, vanServiceList, payinServiceList]);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          heigh: "40px",
          width: "40px",
          cursor: "pointer",
          border: `1px solid #1E2234`,
          padding: "8px",
          borderRadius: 5
        }}
        onClick={onRefreshPress}
      >
        <TbRefresh size={20} color={primaryColor} />
      </div>
      {role !== CLIENT &&
        (currentTab === 1 ||
          currentTab === 2 ||
          currentTab === 3 ||
          currentTab === 4) && (
          <CustomSelect
            options={
              currentTab === 2 || currentTab === 3
                ? payoutServiceList
                : currentTab === 4
                ? vanServiceList
                : currentTab === 5
                ? "neokred"
                : payinServiceList
            }
            isSearchable={false}
            onChange={(data) => {
              onChange(data?.value);
              setCurrentService(data);
            }}
            value={currentService}
            style={{
              height: 40,
              backgroundColor: "rgba(111, 108, 255, 0.1)",
              border: "1px solid #001777",
              "&:hover": {
                border: "1px solid #001777"
              },
              borderRadius: "4px"
            }}
          />
        )}
      <CustomButton
        title="Download Report"
        backgroundColor="#38369C"
        onClick={onPress}
      />
    </div>
  );
};

const tabs = [
  // { name: "All", key: 0, aclValue: TRANSACTION_ALL_ACL },
  { name: "Payin", key: 1, aclValue: TRANSACTION_PAYIN_ACL },
  { name: "Payout", key: 2, aclValue: TRANSACTION_PAYOUT_ACL },
  { name: "Prefund", key: 3, aclValue: TRANSACTION_PREFUND_ACL },
  { name: "Van", key: 4, aclValue: TRANSACTION_VAN_ACL },
  { name: "Voucher", key: 5, aclValue: VOUCHER_TRANSACTION_LIST }
  // { name: "Refund", key: 4, aclValue: TRANSACTION_REFUND_ACL },
  // { name: "Failed", key: 5, aclValue: TRANSACTION_FAILED_ACL },
];

function TransactionIndex() {
  const dispatch = useDispatch();
  const [currentTab, setCurrentTab] = useState(1);
  const [reportModal, setReportModal] = useState(false);
  const [selectedService, setSelectedService] = useState("");
  const filters = useSelector((state) => state.globalFiltersSlice);
  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);
  const [tabsData, setTabsData] = useState([]);
  const [clientDetails, setClientDetials] = useState({});
  const [clientPayoutDetails, setClientPayoutDetails] = useState({});
  const [clientVanDetails, setClientVanDetails] = useState({});
  const [clientVoucherdetails, setClientVoucherdetails] = useState({});
  const role = secureStorage.getItem(SS_ROLE);

  const aclData = useSelector((state) => state.aclSlice.aclList);

  useEffect(() => {
    let tabData = setTabsAccToAcl(tabs, aclData);

    setTabsData([...tabData]);

    setCurrentTab(tabData[0] ? tabData[0]?.key : null);
  }, []);

  const getClientProgram = () => {
    let payout = clientSecret.filter((obj) => obj.serviceType === "payout");
    let payin = clientSecret.filter((obj) => obj.serviceType === "payin");
    let van = clientSecret.filter((obj) => obj.serviceType === "van");
    let voucher = clientSecret.filter((obj) => obj.serviceType === "voucher");
    if (payout.length > 0) {
      setClientPayoutDetails(payout[0]);
    }
    if (payin.length > 0) {
      setClientDetials(payin[0]);
    }
    if (van.length > 0) {
      setClientVanDetails(van[0]);
    }
    if (voucher.length > 0) {
      setClientVoucherdetails(voucher[0]);
    }
  };

  useEffect(() => {
    if (role === CLIENT) {
      getClientProgram();
    }
  }, []);

  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 15);
  const defaultDateRange = `${("0" + startDate.getDate()).slice(-2)}/${(
    "0" +
    (startDate.getMonth() + 1)
  ).slice(-2)}/${startDate.getFullYear()}-${("0" + endDate.getDate()).slice(
    -2
  )}/${("0" + (endDate.getMonth() + 1)).slice(-2)}/${endDate.getFullYear()}`;

  return (
    <div
      style={{
        width: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        backgroundColor: "white"
      }}
    >
      <MainComponent
        notificationRequired={false}
        onClickFilter={() => {
          dispatch(
            showHideFilterModalReducer({
              showFilterModal: true,
              filters: [
                "dateRange",
                "clientName",
                "resellerName",
                "transactionStatus",
                "custRefNo",
                "transactionId",
                "vanNumber"
              ]
            })
          );
        }}
        headerTitle="Transactions"
        onClickFilterCall={(data) => {
          dispatch(
            fetchTransactionList({
              dateRange:
                data?.fromDate && data?.toDate
                  ? moment(data?.fromDate).format("DD/MM/YYYY") +
                    "-" +
                    moment(data?.toDate).format("DD/MM/YYYY")
                  : "",
              page: 0,
              size: 10,
              resellerId: data?.resellerId?.value,
              clientId: data?.clientId?.value,
              status: data?.status?.value
                ? data?.status?.value
                : currentTab === 5
                ? data?.status?.value
                : "",
              serviceType:
                currentTab === 0
                  ? ""
                  : currentTab === 1
                  ? "payin"
                  : currentTab === 2
                  ? "payout"
                  : currentTab === 3
                  ? "prefund"
                  : currentTab === 4
                  ? "van"
                  : currentTab === 5
                  ? "voucher"
                  : "",

              custRefNo: data?.custRefNo ?? "",
              transactionId: data?.transactionId ?? "",
              serviceProviderName:
                role === CLIENT
                  ? currentTab === 1
                    ? clientDetails?.serviceProviderName
                    : currentTab === 2
                    ? clientPayoutDetails?.serviceProviderName
                    : currentTab === 3
                    ? clientPayoutDetails?.serviceProviderName
                    : currentTab === 4
                    ? clientVanDetails?.serviceProviderName
                    : currentTab === 5
                    ? "neokred"
                    : ""
                  : selectedService,
              van: data?.van ?? ""
            })
          );
        }}
        // filterRequired={aclData.includes(TRANSACTION_FILTER_ACL)}
      />

      <CustomTabs
        tabs={tabsData}
        activeIndex={currentTab}
        passCurrentTab={(data) => {
          setCurrentTab(data);
          setSelectedService("");
        }}
        actionComponent={
          <FilterComponent
            aclData={aclData}
            currentTab={currentTab}
            onPress={() => setReportModal(true)}
            onChange={(data) => {
              setSelectedService(data);
            }}
            onRefreshPress={() => {
              dispatch(
                fetchTransactionList({
                  dateRange:
                    filters?.fromDate && filters?.toDate
                      ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                        "-" +
                        moment(filters?.toDate).format("DD/MM/YYYY")
                      : defaultDateRange,
                  page: 0,
                  size: 10,
                  resellerId: filters?.resellerId?.value,
                  clientId: filters?.clientId?.value,
                  status: filters?.status?.value ? filters?.status?.value : "",
                  serviceType:
                    currentTab === 1
                      ? "payin"
                      : currentTab === 2
                      ? "payout"
                      : currentTab === 3
                      ? "prefund"
                      : currentTab === 4
                      ? "van"
                      : currentTab === 5
                      ? "voucher"
                      : "",
                  custRefNo: filters?.custRefNo ?? "",
                  transactionId: filters?.transactionId ?? "",
                  transferUniqueNo: filters?.transactionId ?? "",
                  serviceProviderName:
                    role === CLIENT
                      ? currentTab === 1
                        ? clientDetails?.serviceProviderName
                        : currentTab === 2
                        ? clientPayoutDetails?.serviceProviderName
                        : currentTab === 3
                        ? clientPayoutDetails?.serviceProviderName
                        : currentTab === 4
                        ? clientVanDetails?.serviceProviderName
                        : currentTab === 5
                        ? "neokred"
                        : ""
                      : selectedService,
                  van: filters?.van ?? "",
                  mechanism: currentTab === 5 ? "coupon" : ""
                })
              );
            }}
          />
        }
        isActionComponentRequired={aclData.includes(
          TRANSACTION_DOWNLOAD_REPORT_ACL
        )}
      />

      {currentTab === 2 ? (
        <PayoutTransaction selectedService={selectedService} />
      ) : currentTab === 3 ? (
        <PrefundTransaction selectedService={selectedService} />
      ) : currentTab === 4 ? (
        <VanTransaction selectedService={selectedService} />
      ) : currentTab === 5 ? (
        <VoucherTransaction selectedService={selectedService} />
      ) : currentTab === 1 ? (
        <PayinTransaction
          currentTab={currentTab}
          selectedService={selectedService}
        />
      ) : null}

      {reportModal && (
        <CustomModal
          headerTitle="Download Report"
          open={reportModal}
          onClose={() => {
            setReportModal(false);
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800
          }}
        >
          <DownloadReportModal
            onChange={(val) => {
              setReportModal(val);
            }}
            serviceType={
              currentTab === 3
                ? "prefund"
                : currentTab === 2
                ? "payout"
                : currentTab === 4
                ? "van"
                : currentTab === 5
                ? "voucher"
                : "payin"
            }
            selectedService={
              role === CLIENT
                ? currentTab === 1
                  ? clientDetails?.serviceProviderName
                  : currentTab === 2
                  ? clientPayoutDetails?.serviceProviderName
                  : currentTab === 3
                  ? clientPayoutDetails?.serviceProviderName
                  : currentTab === 4
                  ? clientVanDetails?.serviceProviderName
                  : currentTab === 5
                  ? "neokred"
                  : ""
                : selectedService
            }
            onClose={() => {
              setReportModal(false);
            }}
          />
        </CustomModal>
      )}
    </div>
  );
}

export default TransactionIndex;
